import React, { useState, useEffect } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
import getServices from "../../Services/get-service";
import Constant from "../../Constant";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "92%",
  maxWidth: 420,
  bgcolor: "#FFFFFF",
  borderRadius: "20px",
  boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
  outline: "none",
  p: "24px",
  maxHeight: "90vh",
  overflowY: "auto",
};

function PaymentMethodModal({
  open,
  handleClose,
  onBack,
  selectedMethod = "wallet",
  onContinue,
}) {
  const [method, setMethod] = useState(selectedMethod || "wallet");
  const [walletBalance, setWalletBalance] = useState(0);

  useEffect(() => {
    if (open) {
      getServices.getWalletBalance().then(
        (response) => {
          if (response.data.statusCode === 200) {
            const walletData = response.data.data[0];
            setWalletBalance(walletData.availableBalance);
          }
        },
        (error) => {
          console.error(error);
        },
      );
    }
  }, [open]);

  const handleReviewOrder = () => {
    if (onContinue) {
      onContinue(method);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 400,
        sx: { backgroundColor: "rgba(0, 0, 0, 0.6)" },
      }}
    >
      <Fade in={open}>
        <Box sx={modalStyle}>
          {/* Header */}
          <div className="flex items-center justify-between">
            <button
              type="button"
              onClick={onBack || handleClose}
              className="flex items-center gap-2 text-[#1E222B] font-[700] text-[15px] cursor-pointer hover:opacity-80 transition"
            >
              <ArrowBackIcon sx={{ fontSize: 18, color: "#1E222B" }} />
              <span>Back</span>
            </button>

            <button
              type="button"
              onClick={handleClose}
              className="w-9 h-9 rounded-full bg-[#18191B] hover:bg-black text-white flex items-center justify-center cursor-pointer transition shadow-xs"
              aria-label="Close"
            >
              <CloseIcon sx={{ fontSize: 17 }} />
            </button>
          </div>

          {/* Title */}
          <h3 className="text-[14px] font-[700] text-[#1E222B] mt-6 mb-3">
            Payment method
          </h3>

          {/* Payment Options */}
          <div className="space-y-3">
            {/* Wallet Option */}
            <div
              onClick={() => setMethod("wallet")}
              className={`bg-white rounded-2xl border p-3.5 flex items-center justify-between cursor-pointer transition ${
                method === "wallet"
                  ? "border-[#00BC67] ring-1 ring-[#00BC67] shadow-2xs"
                  : "border-gray-200/80 hover:border-gray-300"
              }`}
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-[#CCF2E1] flex items-center justify-center text-[#00BC67] flex-shrink-0">
                  <AccountBalanceWalletOutlinedIcon sx={{ fontSize: 20 }} />
                </div>
                <span className="text-[14px] font-[700] text-[#1E222B]">
                  Wallet
                </span>
              </div>

              <div className="flex items-center gap-3">
                <span className="text-[13px] font-[700] text-[#1E222B]">
                  NGN {Constant.FormatNumber(walletBalance)}
                </span>
                <div
                  className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${
                    method === "wallet" ? "border-[#00BC67]" : "border-gray-300"
                  }`}
                >
                  {method === "wallet" && (
                    <div className="w-2.5 h-2.5 rounded-full bg-[#00BC67]" />
                  )}
                </div>
              </div>
            </div>

            {/* Card Option */}
            <div
              onClick={() => setMethod("card")}
              className={`bg-white rounded-2xl border p-3.5 flex items-center justify-between cursor-pointer transition ${
                method === "card"
                  ? "border-[#00BC67] ring-1 ring-[#00BC67] shadow-2xs"
                  : "border-gray-200/80 hover:border-gray-300"
              }`}
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-[#CCF2E1] flex items-center justify-center text-[#00BC67] flex-shrink-0">
                  <CreditCardOutlinedIcon sx={{ fontSize: 20 }} />
                </div>
                <span className="text-[14px] font-[700] text-[#1E222B]">
                  Card
                </span>
              </div>

              <div className="flex items-center gap-2">
                <span className="text-[13px] font-[700] text-[#1E222B]">
                  **** 2898
                </span>
                {/* Mastercard Circles Badge */}
                <div className="flex items-center -space-x-1.5 ml-1">
                  <div className="w-4 h-4 rounded-full bg-[#EB001B] opacity-90" />
                  <div className="w-4 h-4 rounded-full bg-[#F79E1B] opacity-90" />
                </div>
                <KeyboardArrowDownIcon
                  sx={{ fontSize: 18, color: "#1E222B", ml: 0.5 }}
                />
              </div>
            </div>

            {/* New card button */}
            <div>
              <button
                type="button"
                className="inline-flex items-center gap-1.5 text-[13px] font-[700] text-[#00BC67] bg-[#F5FCF8] hover:bg-[#E8F8F0] px-4 py-2.5 rounded-xl cursor-pointer transition"
              >
                <span>New card</span>
                <AddIcon sx={{ fontSize: 16 }} />
              </button>
            </div>
          </div>

          {/* Review Order CTA Button */}
          <button
            type="button"
            onClick={handleReviewOrder}
            className="w-full py-3.5 rounded-xl bg-[#00BC67] hover:bg-[#00a85c] text-white font-[700] text-[15px] transition shadow-xs cursor-pointer text-center mt-12"
          >
            Review Order
          </button>
        </Box>
      </Fade>
    </Modal>
  );
}

export default PaymentMethodModal;
